import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Col, Row } from 'react-bootstrap';

import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';
import { toDollarFormat, querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';

const propTypes = exact({
  /* eslint-disable react/no-unused-prop-types */
  ticketId: PropTypes.number.isRequired,
  job: PropTypes.object.isRequired,
  /* eslint-enable react/no-unused-prop-types */
});


const JobFacts = (props) => {
  const {
    job,
  } = props;

  const {
    total_billing_revenue: totalBillingRevenue,
    total_worked_hours: totalWorkedHours,
    total_billing_time: totalBillingTime,
    totalWorkedHoursEqualsBilling,
    revenuePerBillableHour,
    revenuePerWorkedHour,
  } = job;

  const highlightColor = (totalWorkedHoursEqualsBilling || totalWorkedHoursEqualsBilling === null) ? '' : 'yellow';
  const billableTime = (totalBillingTime) ? totalBillingTime.to_string : 0;

  const displayRevenuePerBillableHour = (revenuePerBillableHour) || '-';
  const displayRevenuePerWorkedHour = (revenuePerWorkedHour) || '-';

  return (
    <React.Fragment>
      <Row style={{ backgroundColor: highlightColor, margin: '0px' }}>
        <h4>
          <strong>
            <Col md={6}>
              <div className="pull-right">
                <span>
                  Job Billable Hours: {billableTime}
                </span> <br />
                <span>
                  Job Worked Hours: {totalWorkedHours.to_string}
                </span> <br />
                <span>Job Revenue: {toDollarFormat(totalBillingRevenue)}</span>
              </div>
            </Col>
            <Col mdOffset={2} md={4}>
              <div className="pull-left">
                <span> {`$${displayRevenuePerBillableHour}`} / Billable Hr</span> <br />
                <span> {`$${displayRevenuePerWorkedHour}`} / Man Hr</span>
              </div>
            </Col>
          </strong>
        </h4>
      </Row>
    </React.Fragment>
  );
};


JobFacts.propTypes = propTypes;


/* Get all Tickets based on Job Id  that's present */

export const JobFactsTicketFragment = gql`
  fragment JobFactsTicketFragment on Ticket {
    id
    job {
      id
      departments {
        edges {
          node {
            id
            name
          }
        }
      }
      total_billing_revenue
      total_billing_time {
        to_string
      }
      totalWorkedHoursEqualsBilling: total_worked_hours_equals_billing
      revenuePerBillableHour: revenue_per_billable_hour
      revenuePerWorkedHour: revenue_per_worked_hour
      total_worked_hours {
        to_string 
      }
    }
  }
`;

export const GetJobByTicketQuery = gql`
  query GetJobByTicket($ticketId: Int!) {
    ticket(ticket_id: $ticketId) {
      ...JobFactsTicketFragment
    }
  }
  ${JobFactsTicketFragment}
`;

const marshallJobTicketData = ({ data, ownProps }) => {
  const [job] = querySelector(data, '$.ticket.job', []);
  return {
    ...ownProps,
    data,
    job,
  };
};

const queryData = graphql(GetJobByTicketQuery, {
  props: marshallJobTicketData,
  options: { fetchPolicy: 'network-only' },
});

export const enhance = compose(
  queryData,
  queryMetaHandler,
  omitProps(['data']),
);

export default enhance(JobFacts);
